import { SecShape, type SecondaryDef } from '../../sim/secondary';

/** S08 — SCIES ORBITALES. La seule arme dont le rendement dépend de ce que le
 *  joueur fait APRÈS avoir tiré.
 *
 *  ── Le besoin ────────────────────────────────────────────────────────────
 *  La Lance traverse déjà les files, et elle le fait bien : six projectiles
 *  empilés donnent une perforation convaincante sans que le moteur ait jamais
 *  eu à la connaître. Mais cette triche a une conséquence qu'on ne voit qu'en
 *  la comparant à autre chose : la colonne traverse UNE FOIS, dans UN SENS, et
 *  tout est joué à l'instant du clic. Elle ne demande plus rien ensuite.
 *
 *  Le disque revient. La file est payée à l'aller et peut l'être de nouveau au
 *  retour, mais seulement si le joueur est encore là pour le récupérer — et se
 *  tenir immobile pendant une seconde et demie dans un rideau est exactement la
 *  décision que ce jeu existe pour rendre difficile. C'est la première arme du
 *  catalogue qui met en tension le TIR et l'ESQUIVE dans cet ordre-là : les
 *  autres demandent d'être bien placé pour tirer, celle-ci demande de le rester
 *  après.
 *
 *  ── Pourquoi le budget de coupes est commun à l'aller et au retour ───────
 *  Quatre contacts, pas quatre à l'aller plus quatre au retour. Sinon l'arme
 *  vaudrait mécaniquement le double de ce qu'elle annonce, et le garde-fou de
 *  DPS — qui compte les CONTACTS depuis ce lot — la validerait sur la moitié de
 *  sa puissance réelle. Le budget commun rend aussi le retour intéressant à
 *  jouer plutôt qu'automatique : un disque qui a tout dépensé à l'aller rentre
 *  à vide, et le joueur qui l'a vu couper quatre corps sait qu'il n'a plus rien
 *  à attendre.
 *
 *  ── Pourquoi deux disques et pas un ──────────────────────────────────────
 *  Un disque unique impose de choisir sa file avant de tirer, ce qui ramène
 *  l'arme au problème de la Lance. La paire écartée de 96 u couvre deux couloirs
 *  voisins et laisse le choix se faire pendant le vol, au moment du retour — là
 *  où l'arme veut que la décision se prenne.
 *
 *  ── L'équilibrage ────────────────────────────────────────────────────────
 *  60 DPS nominaux (30 % de la primaire) pour 360 dégâts maximum par
 *  déclenchement — le plafond suppose que les huit coupes trouvent un corps, ce
 *  qui exige une file dense à l'aller ET un joueur bien placé au retour. Sur une
 *  cible isolée, elle vaut deux coupes : moins que les Flanqueurs. */
const scie: SecondaryDef = {
  id: 'scies-orbitales',
  name: 'Scies orbitales',
  shape: SecShape.Scie,
  cooldown: 6,
  shots: 1,
  shotEvery: 0,
  count: 2,
  // 96 u entre les deux disques : deux couloirs voisins, pas deux moitiés
  // d'écran. L'arme couvre une zone, elle ne balaie pas le terrain.
  spacing: 96,
  spreadDeg: 0,
  // 900 u/s : assez rapide pour que la traversée d'une file se lise comme une
  // coupe et non comme une dérive, assez lent pour que le demi-tour soit
  // visible. Le demi-tour est l'arme ; s'il ne se voit pas, il n'existe pas.
  speed: 900,
  // Gros rayon : un disque doit toucher ce qu'il frôle. Sa difficulté est dans
  // le placement du VAISSEAU, jamais dans la précision du lancer.
  radius: 22,
  damage: 45,
  // Quatre coupes, aller et retour confondus.
  hits: 4,
  // 0,55 s de montée, soit 495 u : le disque atteint le tiers supérieur du
  // terrain — la zone où stationnent les ennemis postés — puis rentre. Plus
  // long, il sortirait du cadre et rentrerait à vide ; plus court, il ne
  // traverserait rien avant de faire demi-tour.
  duration: 0.55,
  // 300 °/s au retour : un demi-tour en 0,6 s. Assez large pour se lire comme
  // une orbite plutôt que comme un demi-tour instantané, qui aurait l'air d'un
  // bug de trajectoire.
  turnDeg: 300,
  text: '2 disques × 45 dégâts, 4 coupes, aller-retour — 6 s',
};

export default scie;
